import { HOUR_IN_MS } from '../../../utils/time';

export const autoBotConfig = {
  maxRewardDuration: HOUR_IN_MS * 12,
  cooldown: HOUR_IN_MS,
};
